<template>
  <footer id="footer" >
    <!-- 聯絡人，如果使用者有推薦人(折扣碼)則隱藏聯絡人，且顯示折扣碼 -->
    <b-container v-if="contactItems.length>0 && !$store.state.referrer" class="bg-inf pt-5">
      <h5 class="text-center mb-3"><b>聯絡人</b></h5>
      <div>
        <b-table :items="contactItems" :fields="fields" outlined responsive class="bg-white mb-5">
          <template #cell(email)="data">
          <a :href="'mailto:'+data.item.email">{{ data.item.email }}</a>
          </template>
          <template #cell(contact)="data">
          <!-- {{ data.item }} -->
          <a :href="'skype:'+data.item.skype+'?chat'" class="mx-1" v-if="data.item.skype">
            <img src="https://www.ginifab.com/image/skype.png" title="Skype">
          </a>
          <a :href="'https://wpa.qq.com/msgrd?v=3&uin='+data.item.qq+'&site=qq&menu=yes'"
            v-if="data.item.qq" class="mx-1" target="_blank">
            <img src="https://pub.idqqimg.com/qconn/wpa/button/button_121.gif" title="QQ">
          </a>
          <a @click="clickWechat(data.item.name, data.item.wechat)" class="mx-1 pointer" v-if="data.item.wechat">
            <img src="https://www.ginifab.com/image/wechat.png" title="複製WeChat ID">
          </a>
          <a @click="clickLine(data.item.name, data.item.wechat)"
            v-if="data.item.line" class="mx-1 pointer">
            <img src="https://www.ginifab.com/image/line.png" title="複製LINE ID">
          </a>
          <a :href="'https://wa.me/'+data.item.whatsapp" v-if="data.item.whatsapp">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/32px-WhatsApp.svg.png" title="WhatsApp"></a>
          </template>
          <template #cell(phone)="data">
          <a :href="'tel:'+data.item.phone">{{ data.item.phone }}</a>
          </template>
          <template #cell(phone2)="data">
          <a :href="'tel:'+data.item.phone2">{{ data.item.phone2 }}</a>
          </template>
        </b-table>
      </div>
    </b-container>

    <!-- footer資訊 -->
    <div class="footer_info">
      <div class="container smtxt mb-3" v-if="$store.state.referrer">您使用的折扣碼是 {{ $store.state.referrer }}</div>
      <!-- 中文footer -->
      <div class="container" v-if="this.$i18n.locale==='tw'">
        <div class="row">
          <div class="col-lg-4 mb-5 mb-lg-0">
            <img src="@/assets/img/TSTAR_LOGO.png" class="img-fluid mb-3">
            <div>注冊編號交觀甲:6387 品保協會北1797號</div>
            <p>大陸人民來台旅游業務編號:295</p>
            <div class="contact_icon">
              <a href="https://zh-tw.facebook.com/MingRiZhiXingLuXingShe" target="_blank">
                <div class="fb_icon"></div>
              </a>
              <a href="https://lin.ee/g3Cfwi" target="_blank">
                <div class="line_icon"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <p class="title">明日之星旅行社台北總公司</p>
            <div class="contact_info">
              <div>地址：台北市松山區八德路三段210號8樓</div>
              <!-- <div>営業時間：月曜日～金曜日 9:30~18:00(昼休み 12:00~13:00)</div> -->
              <!-- <div>㊡休日：土・日・祝日・年末年始はお休み</div> -->
              <div>電話：(02)2578-5833</div>
              <div>傳真：(02)2578-3984</div>
              <div>E-mail：<a href="mailto: tstar@tstar888.com">tstar@tstar888.com</a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <p class="title">明日之星旅行社高雄公司</p>
            <div class="contact_info">
              <div>地址：高雄市苓雅區四維四路182號</div>
              <!-- <div>営業時間：月曜日～金曜日 9:30~18:00(昼休み 12:00~13:00)</div> -->
              <!-- <div>㊡休日：土・日・祝日・年末年始はお休み</div> -->
              <div>電話：(07)269-2958</div>
              <div>傳真：(07)269-2797</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 日文footer -->
      <div class="container" v-if="this.$i18n.locale==='jp'">
        <div class="row">
          <div class="col-lg-4 mb-5 mb-lg-0">
            <img src="@/assets/img/TSTAR_LOGO.png" class="img-fluid mb-3">
            <!-- <p>注冊編號交觀甲:6387 品保協會北1797號</p>
            <p>大陸人民來台旅游業務編號:295</p> -->
            <div class="contact_icon">
              <a href="https://zh-tw.facebook.com/MingRiZhiXingLuXingShe" target="_blank">
                <div class="fb_icon"></div>
              </a>
              <a href="https://lin.ee/g3Cfwi" target="_blank">
                <div class="line_icon"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <p class="title">㍿ 明日之星(株)旅行社台北事務所</p>
            <div class="contact_info">
              <div>所在地：台北市松山區八德路三段210號8樓</div>
              <div>営業時間：月曜日～金曜日 9:30~18:00(昼休み 12:00~13:00)</div>
              <div>㊡休日：土・日・祝日・年末年始はお休み</div>
              <div>☏電話：+886-2-25785833</div>
              <div>ファックス：+886-2-25783984</div>
              <div>E-mail：<a href="mailto: tstar@tstar888.com">tstar@tstar888.com</a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <p class="title">㍿ 明日之星(株)旅行社高雄事務所</p>
            <div class="contact_info">
              <div>所在地：高雄市苓雅區四維四路182號</div>
              <div>営業時間：月曜日～金曜日 9:30~18:00(昼休み 12:00~13:00)</div>
              <div>㊡休日：土・日・祝日・年末年始はお休み</div>
              <div>☏電話：+886-7-2692958</div>
              <div>ファックス：+886-7-2692797</div>
              <div>E-mail：<a href="mailto: kao_op1@tstar888.com">kao_op1@tstar888.com</a></div>
              <div>携帯電話：886-958-369902</div>
              <div>LINE ID：tstar_kao_op2 (翁樣)</div>
              <div>SKYPE live：kao_op1_1 (翁樣)</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 英文footer -->
      <div class="container" v-if="this.$i18n.locale==='en'">
        <div class="row">
          <div class="col-lg-4 mb-5 mb-lg-0">
            <img src="@/assets/img/TSTAR_LOGO.png" class="img-fluid mb-3">
            <!-- <p>注冊編號交觀甲:6387 品保協會北1797號</p>
            <p>大陸人民來台旅游業務編號:295</p> -->
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <p class="title">TRAVEL STAR</p>
            <div class="contact_info">
              <!-- <div>所在地：台北市松山區八德路三段210號8樓</div> -->
              <div>TEL：+886-2-25785833</div>
              <div>E-mail：<a href="mailto: tstar@tstar888.com">tstar@tstar888.com</a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <div class="contact_icon">
              <a href="https://zh-tw.facebook.com/MingRiZhiXingLuXingShe" target="_blank">
                <div class="fb_icon"></div>
              </a>
              <a href="https://lin.ee/g3Cfwi" target="_blank">
                <div class="line_icon"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright text-center">
      <span style="font-size: 12px;">Copyright © Travel Star Service Co., LTD. All Rights Reserved</span>
    </div>
  </footer>
</template>
<script>
export default {
  metaInfo () {
    const title = this.metaTitle
    const meta = this.metaData
    return { title, meta }
  },
  data () {
    return {
      metaData: [],
      metaTitle: '明日之星',
      fields: [
        // { key: 'office', label: '辦事處' },
        { key: 'name', label: '聯絡人' },
        { key: 'email', label: 'email' },
        { key: 'phone', label: '電話1' },
        { key: 'phone2', label: '電話2' },
        { key: 'contact', label: '線上通訊' }
      ],
      contactItems: [
        // { name: '台北XXX', department: '台北', phone: '0919', skype: '0919', line: 'line123', whatsapp: 'dsad', qq: 'd', wechat: 'd', email: 'adf@dd.dd' },
        // { name: 'XXX', department: '高雄', phone: '02', skype: '0919', line: 'line', whatsapp: '', qq: '', wechat: '' }
      ]
    }
  },
  methods: {
    clickWechat (name, id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          alert('已複製' + name + '的 Wechat ID : ' + id)
        })
        .catch((err) => {
          alert('Wechat ID : ' + id)
          console.error(err)
        })
    },
    clickLine (name, id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          alert('已複製' + name + '的 LINE ID : ' + id)
        })
        .catch((err) => {
          alert('LINE ID : ' + id)
          console.error(err)
        })
    }
  },
  async created () {
    // 查詢後臺設定的meta SEO 並套用
    try {
      const { data } = await this.api.post('php_modules2/site_pages.php?type=r&version=3')
      // console.log(data)
      // 檢查後台是否有設定目前網址的SEO、聯絡人資料，如果有設定，則代入資料
      const dataIsExits = data.data.find(item => item.url === window.location.href)
      // console.log(data.data.find(item => item.url === window.location.href))
      if (dataIsExits) {
        this.contactItems = dataIsExits.contact
        this.metaTitle = dataIsExits.title
        this.metaData.push({
          vmid: 'keywords',
          name: 'keywords',
          content: dataIsExits.keyword
        },
        {
          vmid: 'description',
          name: 'description',
          content: dataIsExits.description
        })
      }
      // esim 單獨介紹頁keywords、description用後台設定的ESIM首頁
      if (this.$route.name === 'EsimDetailPage') {
        const seoData = data.data.find(item => item.url === 'https://tstar888.com/tours/esim')
        this.metaTitle = seoData.title
        this.metaData.push({
          vmid: 'keywords',
          name: 'keywords',
          content: seoData.keyword
        },
        {
          vmid: 'description',
          name: 'description',
          content: seoData.description
        })
      }
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: error
      })
    }

    // esim 單獨介紹頁 title加 esim國家。
    if (this.$route.name === 'EsimDetailPage') {
      try {
        const { data } = await this.api.post(
          'php_modules2/esim.php?type=rateplanlist&language=tw&product_category_name=' + this.$route.params.plan)
        this.metaTitle = 'eSIM 網卡 ' + data.transformedData[0].country[0].name + this.metaTitle
      } catch (error) {
        console.log(error)
      }
    } else
    // 旅遊團SEO及聯絡人額外設定
    if (this.$route.name === 'TourPage') {
      try {
        const { data } = await this.api.post(
          'php_modules2/tour.php?type=r&id=' + this.$route.params.id)
        // console.log('footer tour')
        // console.log(data)
        this.tour = data.data[0]
        this.metaTitle = this.tour.metaInfo.title
        this.metaData.push({
          vmid: 'description',
          name: 'description',
          content: this.tour.metaInfo.description
        },
        {
          vmid: 'keyword',
          name: 'keyword',
          content: this.tour.metaInfo.keywords
        })
      } catch (error) {
        console.log(error)
      }
      // 旅團的聯絡人是依照旅團的設定，而不是admin seo3的設定
      try {
        const { data } = await this.api.post('php_modules2/contacts.php?type=r')
        this.contactItems = data.data
        this.contactItems = this.contactItems.filter(item => this.tour.contactsId.includes(item.id))
      } catch (error) {
        console.log(error)
      }
    }
    // console.log('contactItems')
    // console.log(this.contactItems)
  }
}
</script>

<style lang="scss">
#footer {
  thead {
    background-color: var(--myblue);
    color: #fff;
  }
  tbody tr:hover {
    background-color: #fff !important;
  }
  .table thead th {
    border: none;
  }
  .title {
    font-weight: 500;
  }
  .footer_info {
    padding: 3rem 0rem 1.5rem;
    color: rgb(61, 61, 61);
    background: linear-gradient(rgba(0, 0, 0, 0.13) 0% , #e7e7e7 20px);
    letter-spacing: 1px;
  }
  footer i {
    font-size: 2rem;
    box-shadow: 0px 0px #fff;
  }
  footer a {
    border-radius: 30px;
    width: 40px;
    height: 40px;
  }
  footer .contact_info {
  color: #cecece;
  line-height: 2rem;
  word-spacing: 1px;
  font-size: 15px;
  }
  footer .contact_info a {
    color: #cecece;
    text-decoration: underline;
  }
  .copyright {
    color: #fff;
    background-color: #878787;
    padding: 5px;
  }
}
</style>
